import { makeStyles } from '@material-ui/styles';

const HEADER_HEIGHT = 64;

export default makeStyles(() => ({
  container: {
    width: '100%',
    height: '100%',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    overflow: 'scroll',
  },
  header: {
    height: HEADER_HEIGHT,
    position: 'relative',
    padding: 24,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  backButton: {
    left: 10,
    position: 'absolute',
  },
  paper: {
    height: `calc(100% - ${HEADER_HEIGHT}px)`,
    width: '100%',
  },
}));



// WEBPACK FOOTER //
// ./src/components/LoanOfficerMessages/components/MobileMessages/components/ActionPage/useStyles.js